import type React from 'react';
import type {
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from 'react-hook-form';
import InputT from './InputT';

type NumberInputProps<T extends FieldValues> = {
  id?: string;
  field?: Path<T>;
  placeholder?: string;
  options?: RegisterOptions<T>;
  control?: Control<T>;
  parentClassName?: string;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export function NumberInputT<T extends FieldValues>({
  id,
  field,
  placeholder,
  options,
  control,
  parentClassName,
  ...restParams
}: NumberInputProps<T>) {
  const { pattern, valueAsDate, min, max, ...restOptions } = options || {};
  const { className } = restParams;

  return (
    <InputT
      id={id}
      type='number'
      placeholder={placeholder}
      field={field}
      control={control}
      min={min?.toString()}
      max={max?.toString()}
      options={{ valueAsNumber: true, ...restOptions }}
      className={className}
      parentClassName={parentClassName}
    />
  );
}

export default NumberInputT;
